enum ETransactionStatus {
  Null = 'null',
  Done = 'done',
  Cancelled = 'cancelled',
}

export default ETransactionStatus;
